export default __webpack_public_path__ + "models/model.dae";